// UAT environment configuration
// This is used when building for UAT deployment

export const environment = {
  production: true,
  apiBaseUrl: 'https://func-uat-payroll-client-api-gateway.azurewebsites.net',
  aadTenantId: '9891dc79-e49c-4297-a8ec-1c3316e7825a',
  aadClientId: '73e18faa-bd10-4788-8d90-89d965395de3' // Overridden at build time by pipeline from $(aad_client_id) variable group
};
